import { Box, Button } from '@mui/material';

import StepGuide from '../../../../../../components/StepGuide';
import { useImportStepData } from '../../../../../../state/survey-form';
import { generateImportSheet } from '../util';

type ImportTemplateStepProps = {
  stepNumber: number;
};

export default function ImportTemplateStep({
  stepNumber,
}: ImportTemplateStepProps) {
  const { columns, name } = useImportStepData();

  function onClickDownload() {
    generateImportSheet(columns, name);
  }

  return (
    <Box my={2} display="flex" flexDirection="column" alignItems="center">
      <StepGuide
        stepNumber={stepNumber}
        text="Download the unique template file for this survey and then add your data
        to the correct columns."
      />
      <Box mt={2}>
        <Button onClick={onClickDownload} variant="contained" color="secondary">
          Download Import Template
        </Button>
      </Box>
    </Box>
  );
}
